<nz-switch [(ngModel)]="value" (click)="handleValueChange()" [nzDisabled]="disabled" data-cy="switch-toggle"></nz-switch>
@if (label) {
  <span class="switch-label">{{ label }}</span>
}